(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bn-hero-scroll"] && !Shopify.designMode) return;
  try {
    class BnHeroScroll extends HTMLElement {
    connectedCallback() {
      this.hero = this.closest('.hero');
      if (!this.hero) return;
      this.wrapper = document.querySelector('.page-wrapper');

      this.querySelector('button')?.addEventListener('click', () => {
        const header = document.querySelector('#header-group .header-section, #header-group');
        const sticky = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position);
        const offset = sticky ? header.getBoundingClientRect().bottom : 0;
        const top = this.scrollTop + this.hero.getBoundingClientRect().bottom - offset;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
      });

      const strength = Number(this.dataset.strength) / 100;
      if (this.dataset.parallax !== 'true' || !strength) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.media = this.hero.querySelector('.hero__media-grid');
      if (!this.media) return;
      this.media.setAttribute('data-bn-parallax', '');
      this.strength = strength;
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => this.update());
      };
      /* Horizon: da 990 px in su scorre `.page-wrapper`, sotto scorre la finestra. Si ascoltano entrambi. */
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.wrapper?.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      if (!this.onScroll) return;
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.wrapper?.removeEventListener('scroll', this.onScroll);
      if (this.media) {
        this.media.style.transform = '';
        this.media.style.top = '';
        this.media.removeAttribute('data-bn-parallax');
      }
    }

    get scroller() {
      const wrapper = this.wrapper;
      if (wrapper && ['auto', 'scroll'].includes(getComputedStyle(wrapper).overflowY)) return wrapper;
      return window;
    }

    get scrollTop() {
      const scroller = this.scroller;
      return scroller === window ? window.scrollY : scroller.scrollTop;
    }

    update() {
      this.ticking = false;
      const rect = this.hero.getBoundingClientRect();
      const scrollTop = this.scrollTop;
      const offsetTop = rect.top + scrollTop;
      const scrolled = Math.min(Math.max(scrollTop, 0), offsetTop + rect.height);
      this.media.style.top = `${-Math.ceil(offsetTop * this.strength)}px`;
      this.media.style.transform = `translate3d(0, ${Math.round(scrolled * this.strength)}px, 0)`;
    }
  }

  if (!customElements.get('bn-hero-scroll')) {
    customElements.define('bn-hero-scroll', BnHeroScroll);
  }
  } catch(e) { console.error(e); }
})();

})();
